import script from "./VAppLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAppLayout.vue?vue&type=script&setup=true&lang=ts"

import "./VAppLayout.vue?vue&type=style&index=0&id=3b4b0461&lang=scss"

const __exports__ = script;

export default __exports__